export enum NtSource {
    Device = 1,
    Server = 2,
    All = Device | Server
}

export enum NtType {
    CardRead = 1,
    PaymentRequest = 2,
    PaymentCancel = 4
}

export interface INtNotification {
    time: string|Date;
    type: NtType;
    source: NtSource;
    payload: object | string;
}

export enum PaymentResult {
    Success = 1,
}

export interface IApiError {
    message: string;
    code: string;
    stackTrace: string;
}

export type ResourceName =
    "*" |
    "SalePoint" |
    "SaleCircuit" |
    "PaymentCard" |
    "Wallet" |
    "Order" |
    "Product" |
    "ProductCatalog" |
    "System" |
    "UserSession" |
    "Device" |
    "Merchant" |
    "Customer" |
    "Report";

export type ResourceScope =
    "*" |
    "owner" |
    "admin" |
    "read" |
    "write" |
    "delete" |
    "list" |
    "edit" |
    "charge" |
    "sell" |
    "manage_security" |
    "manage_products" |
    "manage_sale_circuits" |
    "not_create" |
    "create_charge" |
    "create_buy" |
    "manage" |
    "create";


export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export class AccessPermission {

    resource: ResourceName; 

    scope: ResourceScope;   

    resourceId?: string;


    static parse(text: string): AccessPermission {

        const parts = text.split(':');

        if (parts.length < 2 || parts.length > 3) 
            throw new Error(`Invalid access permission format: ${text}`);

        const res = new AccessPermission(); 

        if (parts[0] != "*")
            res.resource = parts[0] as ResourceName;

        if (parts[1] != "*")
            res.scope = parts[1] as ResourceScope;  

        if (parts.length > 2 && parts[2] != "*")
            res.resourceId = parts[2];

        return res;
    }
}